
      import logoUrl from '/src/assets/images/logo.png';

      const preloaderLogo = document.querySelector('[data-vs-logo]');

      if (preloaderLogo) {
        preloaderLogo.src = logoUrl;
      }
    